import styled from "styled-components";
import { themeGet, size } from "styled-system";
import { Box } from "rebass";
import SVG from "react-inlinesvg";

const Arrow = ({ ariaLabel, className, size, onClick, direction = "down" }) => {
  let rotation;
  switch (direction) {
    case "left":
      rotation = "rotate(90deg)";
      break;
    case "right":
      rotation = "rotate(-90deg)";
      break;
    case "up":
      rotation = "rotate(180deg)";
      break;
    default:
      rotation = "rotate(0deg)";
      break;
  }
  return (
    <S_Arrow
      className={className}
      rotation={rotation}
      onClick={onClick}
      as="button"
      size={size}
      aria-label={ariaLabel ? ariaLabel : direction}
    >
      <SVG src="/static/images/octagon.svg" />
    </S_Arrow>
  );
};

const S_Arrow = styled(Box)`
  ${size}
  display: block;
  transform: ${props => props.rotation};
  background: none;
  appearance: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &:hover {
    svg {
      transform: scale(1.1, 1.1);

      .octagon {
        transform: rotate(33deg);
      }
    }
  }

  svg {
    width: 100%;
    height: 100%;
    transition: transform 0.3s cubic-bezier(0.465, 0.183, 0.153, 0.946);

    .octagon {
      fill: ${themeGet("colors.white")};
      transform-origin: center;
      transition: transform 0.3s cubic-bezier(0.465, 0.183, 0.153, 0.946);
    }

    .arrow {
      fill: ${themeGet("colors.blue.2")};
    }
  }
`;

export { Arrow };
